import { BaseButton } from '@/components/common/base-button';
import CloseIcon from '@/components/icons/CloseIcon';
import type { BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';

type ShopFnbClearButtonProps = BaseButtonProps & {
    onClick: () => void;
};

const ShopFnbClearButton = ({ onClick, ...props }: ShopFnbClearButtonProps) => {
    return (
        <BaseButton {...props} onClick={onClick} className={styles['clear-button']}>
            <CloseIcon width={12} height={13} color="currentColor" />
        </BaseButton>
    );
};

export default ShopFnbClearButton;
